import './error.scss';
import { useNavigate } from 'react-router-dom';
import { BrandButton } from './form/buttons';

const LoadError = () => {
    const navigate = useNavigate();
    return(
        <div className="loadError">
            <div className="errorContent">
            <p>The application has timed out. You need to login.</p>
            <BrandButton onClick={() => navigate('/login', { replace: true })}>LOGIN</BrandButton>
            </div>
        </div>
    )
}
export default LoadError;